export const isCurrentPage = ({ id }: { id?: string }) => {
  const url = window.location.toString()
  return !!id && url.includes(id?.toString())
}
